import { render } from "./CardStyleBG.vue?vue&type=template&id=7681522b&ts=true"
import script from "./CardStyleBG.vue?vue&type=script&lang=ts"
export * from "./CardStyleBG.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__